import { useContext, useRef, useState } from "react";
import { Checkbox, InputSearch } from "iuvity-ui-components/dist";
import { OverlayPanel } from "iuvity-ui-components/dist/overlaypanel";
import { AppContext } from "../../context/index";

interface TableHeaderProps {
  title: string;
  filters: any;
  setFilters: React.Dispatch<React.SetStateAction<any>>;
  columns: Array<Column>;
  selectedColumns: Array<Column>;
  toggleColumns: React.Dispatch<React.SetStateAction<Array<Column>>>;
  reload?: Function;
  hasCheckColumn?: boolean;
  onClearFiltersColumn?: any;
  globalFilterValue?: any;
  showInputSearch?: boolean;
}

interface Column {
  field: string;
  header: string;
  [key: string]: any;
}

export const TableHeader: React.FC<TableHeaderProps> = ({
  title,
  filters,
  setFilters,
  columns,
  selectedColumns,
  toggleColumns,
  reload,
  hasCheckColumn=false,
  onClearFiltersColumn,
  globalFilterValue,
  showInputSearch=true,
}) => {
  const columnsToFilter = columns.filter((elem) => elem.field !== 'actions')
  const op = useRef<any>(null);
  const { t } = useContext(AppContext);
  const [toggleColumnsActive, setToggleColumnsActive] =
    useState<boolean>(false);
  // const [value, setValue] = useState<string>(filters.global.value || "");
  const [value, setValue] = useState<string>(globalFilterValue?.value || "");

  const updateSearch = (value: string) => {
    setFilters((prev: any) => ({
      ...prev,
      global: {
        ...prev.global,
        value,
      },
    }));
    setValue(value);
  };

  let idxActions = -1;
  columns.map((elem, idx) => elem.field === 'actions' ? idxActions = idx : null)

  const onChangeAll = (e: any) => {
    if (e.checked) {
      toggleColumns(columns);
    } else {
      if (idxActions !== -1) {
        hasCheckColumn ? toggleColumns([columns[0], columns[1], columns[idxActions]])
        : toggleColumns([columns[0], columns[idxActions]]);
      }
      else {
        hasCheckColumn ? toggleColumns([columns[0], columns[1]]) : toggleColumns([columns[0]]);
      }
    }
  };

  const onColumnChange = (e: any) => {
    let newSelectedColumns;
    const fixedColumn = idxActions !== -1 ? 2 : 1
    if (selectedColumns.length > fixedColumn || (selectedColumns.length === fixedColumn && e.checked)) {
      if (e.checked) {
        const currentColumnsFields = selectedColumns!.map((col) => col.field);
        const toggledColumn = columns!.find((col) => col.field === e.target.name);
        newSelectedColumns = columns!.filter((col) =>
          [toggledColumn!.field, ...currentColumnsFields].includes(col.field)
        );
      } else {
        newSelectedColumns = selectedColumns?.filter(
          (col) => col.field !== e.target.name
        );
      }
      toggleColumns(newSelectedColumns);
    }
    else {
        e.checked = !e.checked
    }
  };

  return (
    <div className="flex justify-content-between">
      <div className="flex gap-1 table-header-title">
        <h3>{title}</h3>
      </div>
      <div className="flex align-items-center gap-4 mr-4">
        {
          showInputSearch &&
          <InputSearch
            id="datatable-inputSearch"
            placeholder={t("TableHeader.searchPlacehoder")}
            value={value}
            setValue={updateSearch}
          />
        }
        {reload && (
          <i
            id="iconRefresh"
            className="iu iu-icon-refresh dt-header-icon"
            aria-hidden="true"
            title={t("TableHeader.refreshLabel")}
            onClick={() => {
              setValue('');
              onClearFiltersColumn();
            }}
          />
        )}
        <i
          id="iconColumns"
          className={`iu iu-icon-columns dt-header-icon ${
            toggleColumnsActive ? "active" : ""
          }`}
          title={t("TableHeader.filterLabel")}
          aria-hidden="true"
          onClick={(e) => op?.current?.toggle(e)}
        />

        <OverlayPanel
          ref={op}
          id="overlay_panel_datatable"
          style={{ width: "230px", height: "225px", overflowY: "scroll", borderBottom: "5px solid var(--cardBackgroundColorOne)", }}
          showCloseIcon
          onHide={() => setToggleColumnsActive(false)}
          onShow={() => setToggleColumnsActive(true)}
        >
          <span className="p-input-icon-right mb-3">
            <div className="field-checkbox">
              <Checkbox
                key={1}
                inputId="colAll"
                name="colAll"
                value={-1}
                onChange={onChangeAll}
                checked={
                  JSON.stringify(columns.map((col) => col.field)) ===
                  JSON.stringify(selectedColumns.map((col) => col.field))
                }
                disabled={false}
                required={false}
              />
              <label htmlFor="colAll">{t("TableActions.allColumns")}</label>
            </div>
          </span>
          {columnsToFilter.map((column, index) => {
            return (column.header !== '' &&
              <div key={`${column.field}-${index}`} className="field-checkbox">
                <Checkbox
                  inputId={column.field}
                  name={column.field}
                  value={index}
                  onChange={onColumnChange}
                  checked={
                    !!selectedColumns.find((col) => col.field === column.field)
                  }
                  disabled={column.field === 'actions'}
                  required={false}
                />
                <label htmlFor="colName">{column.header === 'Error' ? 'Error' : t(column.header)}</label>
              </div>
            );
          })}
        </OverlayPanel>
      </div>
    </div>
  );
};
